import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchQuickFilterDetails, filterMapApi, masterDataApi, preSignDelete, preSignDownload, preSignEntry, preSignEntryPatch, preSignFetch, preSignUpload, preSignUploadAWS, projectsFilterApi, reverseGeocode, userCapabilitiesApi } from "./service";
import { OptionType } from "./shared/context/FilterContext";
import { commentsAndlogs } from "./shared/api/commentsAndLogs";

export const useMasterdata = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            return await masterDataApi.fetch();
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useUserCapabilities = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            return await userCapabilitiesApi.fetch();
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useFilterMap = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            return await filterMapApi.fetch();
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useProjectsFilter = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            return await projectsFilterApi.fetch();
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useFetchQuickFilterDetails = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (apiEndPoint: OptionType) => {
            return await fetchQuickFilterDetails.fetch(apiEndPoint);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useFetchLocationDetails = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ lat, lng }: { lat: number, lng: number }) => {
            return await reverseGeocode.fetch({ lat, lng });
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useHandlePreSignFetch = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (params?: any) => {
            return await preSignFetch.fetch(params);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useHandlePreSignDownload = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (params?: any) => {
            return await preSignDownload.fetch(params);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useHandlePreSignDelete = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (params?: any) => {
            return await preSignDelete.fetch(params);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useHandlePreSignUpload = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (params?: any) => {
            return await preSignUpload.fetch(params);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useHandlePreSignUploadAWS = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (params?: any) => {
            return await preSignUploadAWS.fetch(params);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useHandlePreSignEntry = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (params?: any) => {
            return await preSignEntry.fetch(params);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useHandlePreSignEntryPatch = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (params?: any) => {
            return await preSignEntryPatch.fetch(params);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useGetLogs = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (params?: any) => {
            return await commentsAndlogs.getLogs(params);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useGetComments = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (params?: any) => {
            return await commentsAndlogs.getComments(params);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
           
           
        },
    });
};

export const usePostComments = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (payload?: any) => {
            return await commentsAndlogs.postComments(payload);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
            await qc.refetchQueries({ queryKey: ["query-listing-states"] });
        },
    });
};